import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";
import { pt } from "date-fns/locale";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleXmark, faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import CustomSelectArray from "./CustomSelectArray";
import { Row, Col, Card } from "react-bootstrap";
import { getReservationSums } from "../actions/restaurantActions";
import { FilterSvgIcon, ClockSvgIcon } from "../icons/SvgIcons";
import CustomSelectArrayOfObjects from "../components/CustomSelectArrayOfObjects";
const StyledDatePickerWrapper = styled.div`
  width: 100%;
  font-size: 1.5rem;
  justify-content: center;

  .react-datepicker {
    font-size: 16px;
    height: 370px;
    border: none;
    border-radius: 20px;
    box-shadow: none;
    padding: 10px 0;
    background-color: transparent;
  }

  .react-datepicker__header {
    background-color: transparent;
    border-bottom: 1px solid #e0e0e0;
    padding-top: 20px;
  }

  .react-datepicker__current-month {
    font-size: 20px;
    font-weight: 600;
    color: #99b0ad;
    text-align: center;
    margin-bottom: 10px;
  }

  .react-datepicker__day-names {
    margin-top: 10px;
  }

  .react-datepicker__day-name {
    color: #888;
    font-weight: 500;
    font-size: 14px;
  }

  .react-datepicker__day {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    font-size: 14px;
    margin: 2px;
    border-radius: 10px;
    position: relative;
  }

  .react-datepicker__day--selected {
    background-color: #ee754c !important;
    color: white !important;
    border-radius: 10px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #d4d4d4;
    color: black;
  }

  .react-datepicker__day:hover {
    background-color: #f79574 !important;
    opacity: 1 !important;
    transform: none !important;
    box-shadow: none !important;
    color: white !important;
  }

  .react-datepicker__day--selected:hover {
    background-color: #ee561b !important;
  }

  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--next {
    background-color: white;
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: black;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 2%;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    z-index: 2;
    transition: all 0.2s ease;
  }

  .react-datepicker__navigation--previous {
    left: 5px;
    padding-right: 6px;
  }

  .react-datepicker__navigation--next {
    right: 5px;
    padding-left: 6px;
  }

  .react-datepicker__navigation--previous:hover,
  .react-datepicker__navigation--next:hover {
    background-color: #f0f0f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  .date-sums {
    display: flex;
    width: 100%;
    height: 100%;
    max-height: 2.5rem;
    justify-content: center;
    position: relative;
  }

  .sum-left {
    position: absolute;
    background-color: #f9e100;
    border-radius: 50%;
    padding: 2px;
    font-size: 12px;
    color: black;
    left: 4px;
    bottom: -3px;
    transform: translateX(-26%);
    height: 16px;
    line-height: 16px;
  }

  .sum-right {
    position: absolute;
    background-color: #9fbbc1;
    border-radius: 50%;
    padding: 2px;
    font-size: 12px;
    color: white;
    right: 4px;
    bottom: -3px;
    transform: translateX(26%);
    height: 16px;
    line-height: 16px;
  }

  .warning-indicator {
    position: absolute;
    background-color: #ff4000;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    top: -2px;
    left: -2px;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;
const Cube = styled.div`
  width: 50px;
  height: 50px;
  position: relative;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10px;
  padding-bottom: 15px;
`;
const Container = styled.div`
  width: 100%;
  max-width: 400px;
  position: relative;
  transition: all 0.3s ease;

  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const FiltersRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding-top: 5px;
  margin-left: 30px;
`;
const FilterIconBox = styled.div`
  background-color: #99b0ad;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  align-self: stretch;
`;
const FiltersWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
`;
function CustomDatePicker({
  handleTimeChange,
  date,
  handleCloseDateModal,
  restaurant_id
}) {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const today = new Date();
  const reservationSumss = useSelector(state => state.reservationSums);
  const {
    reservationSums,
    isLoadingReservationSums,
    errorReservationSums
  } = reservationSumss;
  const [selectedDate, setSelectedDate] = useState(today);
  const [highlightedDates, setHighlightedDates] = useState({});
  const [closeModal, setCloseModal] = useState(false);
  const [updateMachine, setUpdateMachine] = useState(false);
  const [shiftWithAll, setShiftWithAll] = useState([]);
  const [selectedShifts, setSelectedShifts] = useState([]);
  const [visibleMonthDate, setVisibleMonthDate] = useState(new Date());
  const handleSelectChangeShift = newSelectedItems => {
    setSelectedShifts(newSelectedItems);
  };
  useEffect(() => {
    if (reservationSums) {
      const filterNames = reservationSums.filter_names && reservationSums.filter_names.length > 0 ? reservationSums.filter_names : reservationSums.date_summary && reservationSums.date_summary.length > 0 ? Object.keys(reservationSums.date_summary[0]).filter(k => k !== "date" && k !== "all") : [];
      const normalizedNames = filterNames.map((name, i) => {
        if (name && name.trim() !== "") return name;
        const filterObj = reservationSums.date_summary?.[0] ?? null;
        if (filterObj) {
          const keys = Object.keys(filterObj).filter(k => k !== "date" && k !== "all");
          const key = keys[i];
          const shift = filterObj[key];
          if (shift && shift.start_time && shift.end_time) {
            return `${shift.start_time} - ${shift.end_time}`;
          }
        }
        return `Filtro ${i + 1}`;
      });
      setShiftWithAll(normalizedNames);
      setSelectedShifts(["tudo", ...normalizedNames]);
    }
  }, [reservationSums]);
  const handleVisibleMonthDispatch = dateInMonth => {
    const middleOfMonth = new Date(dateInMonth.getFullYear(), dateInMonth.getMonth(), 15);
    const formattedDate = `${middleOfMonth.getFullYear()}-${String(middleOfMonth.getMonth() + 1).padStart(2, "0")}-${String(middleOfMonth.getDate()).padStart(2, "0")}`;
    dispatch(getReservationSums(restaurant_id, formattedDate));
  };
  useEffect(() => {
    const datesWithSums = {};
    if (reservationSums && reservationSums.date_summary) {
      const hasTudo = selectedShifts.includes("tudo");
      reservationSums.date_summary.forEach(dateSummary => {
        const {
          date,
          ...shiftSums
        } = dateSummary;
        const shiftsData = {
          sum1: 0,
          sum2: 0,
          warning: false
        };

        /*
          IMPORTANT:
          When "tudo" is selected, use ONLY "all".
            Before, this used Object.keys(shiftSums), which included:
          - all
          - every filter/shift
            That caused double-counting because "all" already contains the whole day.
        */
        const shiftsToCheck = hasTudo ? ["all"] : selectedShifts.filter(shift => shift !== "tudo");
        shiftsToCheck.forEach(shift => {
          if (shiftSums[shift]) {
            shiftsData.sum1 += Number(shiftSums[shift].accepted || 0);
            shiftsData.sum2 += Number(shiftSums[shift].pending_or_edited || 0);
            if (Number(shiftSums[shift].warnings || 0) > 0) {
              shiftsData.warning = true;
            }
          }
        });
        datesWithSums[date] = shiftsData;
      });
      setHighlightedDates(datesWithSums);
    } else {
      setHighlightedDates({});
    }
  }, [reservationSums, selectedShifts]);
  useEffect(() => {
    const formattedDate = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;
    handleTimeChange(formattedDate);
    if (closeModal) {
      handleCloseDateModal();
      setCloseModal(false);
    }
  }, [selectedDate, updateMachine, closeModal]);
  useEffect(() => {
    if (date !== "null") {
      let parts = date.split("-");
      let dateObject = new Date(parts[0], parts[1] - 1, parts[2]);
      setSelectedDate(dateObject);
      handleTimeChange(date);
    }
  }, []);
  const renderDayContents = (day, date) => {
    const dateStr = date.toLocaleDateString("en-GB");
    if (highlightedDates[dateStr]) {
      const {
        sum1,
        sum2,
        warning
      } = highlightedDates[dateStr];
      return <div className="date-sums">
          {warning === true && <div className="warning-indicator"></div>}

          <div className="day">{day}</div>

          <div className="footer">
            {sum2 !== 0 && <div className="sum-left">
                <div className="text">{sum2}</div>
              </div>}

            {sum1 !== 0 && <div className="sum-right">
                <div className="text">{sum1}</div>
              </div>}
          </div>
        </div>;
    }
    return day;
  };
  return <StyledDatePickerWrapper>
      <Container>
        <Row>
          <Col xs={12}>
            <a style={{
            fontSize: "18px"
          }}>{t("ui.components.customDatePickerReservationSums.selecionarHorariosParaVerAsReservas")}</a>

            <br />

            <FiltersRow>
              <FiltersWrap>
                <CustomSelectArrayOfObjects items={shiftWithAll} onSelectChange={handleSelectChangeShift} selectedItems={selectedShifts} fontSize="13px" wrap />
              </FiltersWrap>
            </FiltersRow>
          </Col>
        </Row>

        {reservationSums ? <DatePicker selected={selectedDate} onChange={date => {
        setSelectedDate(date);
        setCloseModal(true);
        setUpdateMachine(!updateMachine);
      }} onMonthChange={date => {
        setVisibleMonthDate(date);
        handleVisibleMonthDispatch(date);
      }} onYearChange={date => {
        const updated = new Date(visibleMonthDate);
        updated.setFullYear(date.getFullYear());
        setVisibleMonthDate(updated);
        handleVisibleMonthDispatch(updated);
      }} dayClassName={date => {
        let classNames = "";
        if (selectedDate && date.getDate() !== selectedDate.getDate() && date.getMonth() !== selectedDate.getMonth() && date.getFullYear() !== selectedDate.getFullYear()) {
          classNames += "react-datepicker__day";
        }
        return classNames.trim();
      }} inline renderDayContents={renderDayContents} locale={pt} weekStartsOn={1} /> : <></>}
      </Container>
    </StyledDatePickerWrapper>;
}
export default CustomDatePicker;
